"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SubModule_1 = require("./SubModule");

var PolymathError_1 = require("../../PolymathError");

var types_1 = require("../../types");

var SetDocument_1 = require("../../procedures/SetDocument");

var RemoveDocument_1 = require("../../procedures/RemoveDocument");
/**
 * Namespace that handles all document Related functionality
 */


var Documents =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Documents, _SubModule_1$SubModul);

  function Documents() {
    var _this;

    _classCallCheck(this, Documents);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Documents).apply(this, arguments));
    /**
     * Retrieve a specific document's data by name
     */

    _this.getDocument = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var contractWrappers, securityToken, symbol, securityTokenInstance, _a, updatedAt, info;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                _context.prev = 2;
                _context.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityTokenInstance = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context.next = 13;
                return securityTokenInstance.getDocument(args);

              case 13:
                _a = _context.sent;
                updatedAt = _a.documentTime;
                info = __rest(_a, ["documentTime"]);
                return _context.abrupt("return", Object.assign({
                  updatedAt: updatedAt
                }, args, info));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));
    };
    /**
     * Retrieve an array of all the documents attached to the security token
     */


    _this.getAllDocuments = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var contractWrappers, securityToken, symbol, securityTokenInstance, documentList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                _context2.prev = 2;
                _context2.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityTokenInstance = _context2.sent;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context2.next = 13;
                return securityTokenInstance.getAllDocuments();

              case 13:
                documentList = _context2.sent;
                return _context2.abrupt("return", Promise.all(documentList.map(function (docname) {
                  return _this2.getDocument({
                    name: docname
                  });
                })));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));
    };

    return _this;
  }
  /**
   * Attach a new document to the contract, or update the URI or hash of an existing attached document
   *
   * @param args.name - should always be unique
   * @param args.uri - off-chain uri of the document from where it is accessible to investors/advisors to read
   * @param args.documentHash - hash of the document's contents
   */


  _createClass(Documents, [{
    key: "set",
    value: function set(args) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new SetDocument_1.SetDocument(Object.assign({
                  symbol: symbol
                }, args), this.context);
                return _context3.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Remove an existing document from the Security Token
     *
     * @param args.name - should always be unique
     */

  }, {
    key: "remove",
    value: function remove(args) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new RemoveDocument_1.RemoveDocument(Object.assign({
                  symbol: symbol
                }, args), this.context);
                return _context4.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return Documents;
}(SubModule_1.SubModule);

exports.Documents = Documents;